import React from "react";
import "./titlecard.css";
import globe from "../assets/AroundtheGlobe.png";
import group from "../assets/Group 1618874170.png";
import vector from "../assets/Vector-7 3.png";


const TitleCard = () => {
  return (
    <div className="title-card">
      <div className="timeline-container">
        <div className="timeline-image">
          <img src={globe} alt="Globe" />
          <img src={vector} alt="Vector" />
          <img src={group} alt="Group" />
        </div>
        <div className="timeline-label">
          <div className="timeline-point-visa"></div>
          <div className="timeline-line-visa"></div>
          <div className="timeline-point-visa"></div>
          <div className="timeline-line-visa"></div>
          <div className="timeline-point-visa"></div>
        </div>
        <div className="timeline-text-container">
            <div className="timeline-text">
                <div className="timeline-title">Choose Your Destination</div>
                <div className="timeline-content">Select your travel destination.</div>
            </div>
            <div className="timeline-text">
                <div className="timeline-title">Upload Documents</div>
                <div className="timeline-content">Share your docs with ease.</div>
            </div>
            <div className="timeline-text">
                <div className="timeline-title">Track Your Visa</div>
                <div className="timeline-content">Watch your visa progress!</div>
            </div>
        </div>
      </div>
    </div>
  );
};

export default TitleCard;